import * as ngCore from '@angular/core'

import * as section from '../../section'

/**
 * TODO:
 */
@ngCore.Component({
  imports: [section.Component],
  selector: 'atn-summit-pulse-employees',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {}
